import React, { useEffect } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import "./BarChart.css";
const BarChart7 = ({ categories = [], series = [] }) => {
  const options = {
    chart: {
      type: "column",
      // type: "columnrange",
    },
    rangeSelector: {
      selected: 2,
    },
    title: {
      text: "Average LOR Vs Monthly",
      align: "left",
    },
    xAxis: {
      categories,
      crosshair: true,
      accessibility: {
        description: "Monthly",
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: "Average LOR",
      },
    },
    tooltip: {
      pointFormat:
        "Monthly: <b>{point.category}</b><br>" +
        "Average_LOR: <b> {point.y}</b><br>",
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
        minPointLength: 3,
      },
    },
    series: [
      {
        name: "Monthly",
        data: series,
      },
    ],
  };
  return <HighchartsReact highcharts={Highcharts} options={options} />;
};
export default BarChart7;